import { useState } from 'react';
export var CheckUserAuthStateEnum;

(function (CheckUserAuthStateEnum) {
  CheckUserAuthStateEnum["unregistered"] = "unregistered";
  CheckUserAuthStateEnum["registered"] = "registered";
})(CheckUserAuthStateEnum || (CheckUserAuthStateEnum = {}));

export var useCheckUserAuthState = function useCheckUserAuthState() {
  var _useState = useState(null),
      userAuthCheckStatus = _useState[0],
      setUserAuthCheckStatus = _useState[1];

  return {
    userAuthCheckStatus: userAuthCheckStatus
  };
};